import React from "react";
import { Link } from "react-router-dom";

import style from "./error.module.scss";
import { Button } from "../../Components/button";
import { translate } from "../../translations/translate";

export const ErrorPage = () => {

  return (<div className={style["wrapper"]}>
    <h1> {translate("error.generic-title")} </h1>
    <div className={style["button-wrapper"]}>
      <Link to="/">
        <Button label={"wtf brp"} />
      </Link>
    </div>
  </div>);
};

export default ErrorPage;
